module.exports = __webpack_public_path__ + "static/media/empty_cart.149d6ea5.png";